export const getCampaignCityPerformanceUrl =
  "/api/v3/campaign/:campaignId/perf/city/:cityId";
export const getCampaignPerformanceByIdUrl =
  "/api/v3/campaign/:campaignId/perf";
